var _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6201,
    cy: 12,
    r: 10.25,
    stroke: "url(#paint0_linear_5763_3956)",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6201,
    cy: 12,
    r: 5.5,
    fill: "url(#paint1_linear_5763_3956)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5763_3956",
    x1: 19.1543,
    y1: 1,
    x2: 1.34283,
    y2: 10.8988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5763_3956",
    x1: 15.8872,
    y1: 6.5,
    x2: 6.98147,
    y2: 11.4494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordIconActive);
export default __webpack_public_path__ + "static/media/record-icon-active.db7b7e8770e6ba513ef48e018f5adb50.svg";
export { ForwardRef as ReactComponent };